import {
  IonButton,
  IonButtons,
  IonModal,
} from '@ionic/react';
import { ReactNode } from 'react';

import styles from './NotificationModal.module.scss';

interface NotsProps {
  showModal: boolean;
  closeModal: () => void;
  title?: string;
  message?: ReactNode;
  canDismiss?: boolean;
}

const DEFAULT_MESSAGE = (
  <>
    ¡Eres un cliente
    <span className={styles.textPepperColor}> VIP</span>
    ! No te pierdas las campañas que tenemos preparadas para ti.
  </>
);

export default function NotificationModal({
  showModal,
  closeModal,
  title = 'Revisa tus campañas',
  message = DEFAULT_MESSAGE,
  canDismiss = true,
}: NotsProps) {
  return (
    <div>
      <IonModal
        isOpen={showModal}
        onDidDismiss={closeModal}
        backdropDismiss={canDismiss}
        className={styles.modalNotification}
      >
        <div className={styles.modalContainer}>
          <div className={styles.modalContent}>
            <h4 className={styles.modalTitle}>
              {title}
            </h4>
            <h4>
              {message}
            </h4>
            <IonButtons className={styles.buttons}>
              <IonButton className={styles.buttonClose} onClick={() => closeModal()}>
                Entendido
              </IonButton>
            </IonButtons>
          </div>
        </div>
      </IonModal>
    </div>
  );
}
